import type { FieldDescriptor } from '@/types/fieldDescriptor';

export const MEMBER_PERSONAL_FIELDS: FieldDescriptor[] = [
  {
    id: 'name',
    fieldType: 'TEXT',
    label: 'Name',
    placeholder: 'Name',
    layout: { sectionHeader: 'PERSONAL DETAILS', span: 'half' },
    validation: {
      required: true,
      minLength: 5,
      errorMessage: 'Name must be at least 5 characters',
    },
  },
  {
    id: 'gender',
    fieldType: 'DROPDOWN',
    label: 'Gender',
    placeholder: 'Select gender',
    options: [
      { value: 'Male', label: 'Male' },
      { value: 'Female', label: 'Female' },
    ],
    validation: { required: true, errorMessage: 'Gender is required' },
    layout: { span: 'half' },
  },
  {
    id: 'dateOfBirth',
    fieldType: 'DATE',
    label: 'Date of Birth',
    validation: { required: true, errorMessage: 'Date of birth is required' },
    layout: { span: 'half' },
  },
  {
    id: 'height',
    fieldType: 'COMPOUND_HEIGHT',
    label: 'Height',
    validation: { required: true },
    compoundKeys: { ft: 'heightFt', inches: 'heightInches' },
    layout: { span: 'half' },
  },
  {
    id: 'weight',
    fieldType: 'COMPOUND_WEIGHT',
    label: 'Weight',
    validation: { required: true },
    compoundKeys: { weight: 'weightKg' },
    layout: { span: 'half' },
  },
];
